import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';

export default function PartnersSection() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const partners = [
    { name: 'Christiani & Nielsen (Thai) Public Co., Ltd.', logo: '/media/company_logo/cn.png' },
    { name: 'Token Interior & Design Co. Ltd.', logo: '/media/company_logo/token.png' },
    { name: 'S. Jittragan Construction Co., Ltd.', logo: '/media/company_logo/sj.png' },
    { name: 'C.M.Y.K. Co., Ltd.', logo: '/media/company_logo/cmyk.png' },
    { name: 'Charoen Pokphand Foods Public Co., Ltd.', logo: '/media/company_logo/cpf.png' },
    { name: 'T.C.J. Asia Public Co., Ltd.', logo: '/media/company_logo/tcj.png' }
  ];


  return (
    <section 
      ref={sectionRef}
      id="partners" 
      className={`py-20 bg-blue-50 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className={`text-center mb-16 transition-all duration-1000 delay-200 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            {t('partners.title')}
          </h2>
          <p className="text-xl text-blue-500 font-medium">
            {t('partners.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {partners.map((partner, index) => (
            <div 
              key={index} 
              className={`flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-1000 cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${400 + index * 100}ms` }}
            >
              <img
            src={partner.logo}
            alt={partner.name}
            className="w-20 h-12 object-contain mb-3"
            loading="lazy"
            onError={(e) => { e.currentTarget.src = '/media/company_logo/placeholder.png'; }}
              />
              {/* <i className={`${partner.logo} w-12 h-12 flex items-center justify-center text-4xl text-blue-500 mb-3`}></i> */}
              <p className="text-sm font-medium text-gray-700 text-center">{partner.name}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex justify-end">
          <a
            href="https://online.fliphtml5.com/JSPMEngineeringBrochure/sijh/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {t('partners.brochure')}
          </a>
        </div>
      </div>
    </section>
  );
}
